import React from "react"
import { css } from "styled-components"
import VariantContainer from "./variant-container"
import Breakpoints from "../../components/shared/breakpoints"

const FixedHeaderSpacer = () => {
  return (
    <VariantContainer
      variants={[
        css`
          /* 
          Since the navbar is fixed, we need to create space at the top
          or else it will cover the header
         */
          padding-top: calc(28.84px + calc(24px * 2));
        `,
        css`
          padding-top: calc(28px + calc(24px * 2));
        `,
        css`
          @media (min-width: ${Breakpoints.lgPlus}) {
            padding-top: calc(48px + calc(24px * 2));
          }
        `,
      ]}
    />
  )
}

export default FixedHeaderSpacer
